import cn from 'classnames';
import { SVGAttributes } from 'react';

import { IconType } from './';

export function Icon(
  props: {
    name?: IconType;
    fill?: string;
  } & SVGAttributes<SVGElement>,
) {
  const { name = 'arrowLeft', className, fill, ...rest } = props;

  switch (name) {
    case 'download':
      return (
        <svg
          width={24}
          height={24}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            className={cn([fill])}
            fillRule="evenodd"
            clipRule="evenodd"
            d="m20 10.6-7.327 7.125a.96.96 0 0 1-1.346 0L4 10.6l1.346-1.45L11 14.67V2h2v12.67l5.654-5.52L20 10.6ZM4 20h16v2H4v-2Z"
          />
        </svg>
      );
    case 'externalLink':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            className={cn([fill])}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.24556 4.5H18.5566C19.078 4.50729 19.4927 4.92201 19.5 5.44337V15.7544H17.5882V7.81378L5.90201 19.5L4.5 18.098L16.1862 6.41177H8.24556V4.5Z"
          />
        </svg>
      );
    case 'arrowRight':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...rest}
        >
          <path
            className={cn([fill])}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6 4L21.725 11.3271C22.0917 11.7042 22.0917 12.2958 21.725 12.6729L14.6 20L13.15 18.6543L18.6707 13L2 13V11L18.6707 11L13.15 5.34575L14.6 4Z"
          />
        </svg>
      );
    default:
    case 'arrowLeft':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          <path
            className={cn([fill])}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.4 20L2.275 12.6729C1.90833 12.2958 1.90833 11.7042 2.275 11.3271L9.4 4L10.85 5.34575L5.32931 11L22 11L22 13L5.32931 13L10.85 18.6543L9.4 20Z"
          />
        </svg>
      );
  }
}
